import React, { FC, useEffect, useState } from 'react'
import { Typography } from 'antd'
import { API, getInternalWeatherStationsResponse } from '../../api'
import { NodesList } from '../../components/nodes-list/NodesList'

interface Props {}

export const WeatherStationsPage: FC<Props> = () => {
    const [data, setData] = useState<getInternalWeatherStationsResponse | undefined>()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)

        API.getInternalWeatherStations()
            .then((data) => {
                setData(data as getInternalWeatherStationsResponse)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return (
        <div className="weather-stations-page">
            <Typography.Title level={3}>Weather Stations</Typography.Title>
            <NodesList data={data?.weatherStations} loading={loading} itemLabel="Station" />
        </div>
    )
}
